
import { Options, Vue } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import {
  checkRolePermission,
  dateToDateString,
  formatDate,
  formatDateWithoutTime
} from "@/app/infrastructures/misc/Utils";
import formatInputMoneyWithDecimalV2 from "@/app/infrastructures/misc/common-library/FormatInputMoneyWithDecimalV2";
import { PRICING_EXCHANGE_RATE } from "@/app/infrastructures/misc/RolePermission";
import { ExchangeRateController } from "@/app/ui/controllers/ExchangeRateController";
import { rateStatus } from "@/app/infrastructures/misc/common-library/ExchangeRate";

@Options({
  components: {
    DetailLayout
  },
  computed: {
    isEditAble() {
      return (
        checkRolePermission(PRICING_EXCHANGE_RATE.EDIT) &&
        this.detailData.status.toLowerCase() !== "inactive"
      );
    },
    isDeactivateAble() {
      return (
        checkRolePermission(PRICING_EXCHANGE_RATE.EDIT) &&
        (this.detailData.status.toLowerCase() === "pending" ||
          this.detailData.status.toLowerCase() === "active")
      );
    }
  }
})
export default class Detail extends Vue {
  // misc variable
  get id(): number {
    return Number(this.$route.params.id);
  }

  get title(): string {
    return String(this.detailData.id);
  }

  goEdit() {
    this.$router.push(`/tarif/exchange-rate/${this.id}/edit`);
  }

  // Detail Data
  created() {
    this.getDetail();
  }

  getDetail() {
    ExchangeRateController.getDetailExchange({ id: this.id });
  }

  // Deactivate data
  get openModalDeactivate() {
    return ExchangeRateController.openModalDeactivate;
  }

  onOpenModalDeactivate() {
    ExchangeRateController.setOpenModalDeactivate(true);
  }

  onCloseModalDeactivate() {
    ExchangeRateController.setOpenModalDeactivate(false);
  }

  _onDeactivate() {
    ExchangeRateController._onDeactivateExchange({ id: this.id });
  }

  setRateStatus(status: 'active' | 'pending' | 'inactive') {
    return rateStatus(status)
  }

  createdAt = "";
  createdBy = "";
  updatedAt = "";
  updatedBy = "";

  exchangeRateValue = "";
  effectiveDate = "";

  // Detail Data
  get detailData() {
    const detail = ExchangeRateController.exchangeRateDetail;
    this.createdAt = formatDate(detail.createdAt);
    this.createdBy = detail.createdBy;
    this.updatedAt =
      detail.updatedAt === "0001-01-01T00:00:00Z" || detail.updatedAt === null
        ? formatDate(detail.createdAt)
        : formatDate(detail.updatedAt);
    this.updatedBy = detail.updatedBy;
    this.exchangeRateValue = String(
      `${detail.exchangeRateTo} ${formatInputMoneyWithDecimalV2(detail.exchangeRate, 6, detail.exchangeRateTo)}`
    );
    this.effectiveDate = formatDateWithoutTime(detail.effectiveDate);
    return detail;
  }

  // Loading
  get isLoading() {
    return ExchangeRateController.isLoading;
  }

  // route navigation
  goBack() {
    this.$router.push("/tarif/exchange-rate");
    ExchangeRateController.setPeriodeStart(new Date());
    ExchangeRateController.setPeriodeEnd(new Date());
  }

  // Format Periode
  formatPeriode(start: string, end: string) {
    return `${dateToDateString(start)} - ${dateToDateString(end)}`;
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }

  // Handle Error
  get isError() {
    return ExchangeRateController.isError;
  }
  get errorCause() {
    return ExchangeRateController.errorCause;
  }
}
